import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import CustomPanelTab from "../../common/CustomPanelTab";

import Prompt from "../Prompt";
import OnboardingPromptPlayground from "../OnboardingPromptPlaygroundV2";


function PanelSanbox() {
    const { tab } = useParams();
    const [activeTab, setActiveTab] = useState(null);
    const tabs = [
        { "name": "Prompt", "path": "/prompt" },
        { "name": "Onboarding", "path": "/onboarding" },
    ];

    useEffect(() => {
        const link = (process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_ADMIN_URL : process.env.REACT_APP_ADMIN_URL_DEV);
        activeTab?.path && window.history.pushState({}, "", `${link}sandbox-panel${activeTab?.path}`);
    }, [activeTab]);

    return (
        <div id="sandbox-panel" className="custom-panel">
            <div className="panel-header">
                <h4>Sandbox</h4>
            </div>
            <CustomPanelTab tabs={tabs}
                defaultTab={tabs?.find(t => t?.path == ('/' + tab))}
                setActiveTab={setActiveTab} />

            <div className="panel-content">
                {
                    activeTab?.name == "Prompt" && <Prompt />
                }
                {
                    activeTab?.name == "Onboarding" && <OnboardingPromptPlayground />
                }

            </div>
        </div>
    );
}

export default PanelSanbox;